/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      window.PXUTheme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });

  },
  removeFromCart: function (lineID) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }

      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }



/*Progress Bar--By Total/Subtotal in Cart*/
    
   var progress_bar = $('.ajax-cart-progress-bar .inner-bar');
   var cartTotal = cart.total_price;
   var cartCount = cart.item_count;
   var cartContents = fetch('/cart.js')
   .then(response => response.json())
   .then(data => { updateProgressBar(data, progress_bar, cartTotal); });
  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

function updateProgressBar() {
  var cartJson = '/cart.json';
  async function getCartJson() {
      fetch(cartJson)
      .then((res) => {
          return res.json();
      })
      .then((data) => {
          let totalCart = data.total_price;
          console.log(totalCart, data);

            if (totalCart >= 1000 && totalCart <= 2000) {
              $('.inner-bar').css({'max-width': '20%'}); 
              $('.pb-heading').text("Only $" + (((5000 - totalCart)/100).toFixed(2)) + " left to unlock FREE SHIPPING!");
          }
          else if (totalCart >= 2000 && totalCart <= 3000) {
              $('.inner-bar').css({'max-width': '40%'}); 
              $('.pb-heading').text("Only $" + (((5000 - totalCart)/100).toFixed(2)) + " left to unlock FREE SHIPPING!");
          }
           else if (totalCart >= 3000  && totalCart <= 4000) {
              $('.inner-bar').css({'max-width': '60%'}); 
              $('.pb-heading').text("Only $" + (((5000 - totalCart)/100).toFixed(2)) + " left to unlock FREE SHIPPING!");
          }
          else if (totalCart >= 4000  && totalCart <= 5000) {
              $('.inner-bar').css({'max-width': '80%'}); 
              $('.pb-heading').text("Only $" + (((5000 - totalCart)/100).toFixed(2)) + " left to unlock FREE SHIPPING!");
          }
           else if (totalCart >= 5000)  {
              $('.inner-bar').css({'max-width': '100%'}); 
              $('.pb-heading').text("Congrats! You unlocked FREE SHIPPING");
              confetti();
          }
          else {
            $('.inner-bar').css({'max-width': '0%'}); 
              $('.pb-heading').text("Add $50 to your cart to unlock FREE SHIPPING!");
          }
      })
  }
  getCartJson();
}
updateProgressBar();



/*Progress Bar--By quantity*/
  /*
   var progress_bar = $('.ajax-cart-progress-bar .inner-bar');
   var cartCount = cart.item_count;
   var cartContents = fetch('/cart.js')
   .then(response => response.json())
   .then(data => { updateProgressBar(data, progress_bar, cartCount); });
  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

function updateProgressBar() {
  var cartJson = '/cart.json';
  async function getCartJson() {
      fetch(cartJson)
      .then((res) => {
          return res.json();
      })
      .then((data) => {
        let totalCount = data.item_count;
          console.log(totalCount, data);

            if (totalCount == 1 ) {
              $('.inner-bar').css({'max-width': '25%'}); 
              $('.pb-heading').text("Add 3 more sauces to unlock 30% off! ");
              $('.bottle-icon2, .bottle-icon3, .bottle-icon4 ').css({'opacity': '.3'});
              $('.unlock-wrapper').css({'opacity': '.3'});
              $('.lock-wrapper').css({'opacity': '1'});
          }
          else if (totalCount == 2 ) {
              $('.inner-bar').css({'max-width': '50%'}); 
              $('.pb-heading').text("Add 2 more sauces to unlock 30% off! ");
              $('.bottle-icon3, .bottle-icon4').css({'opacity': '.3'});
              $('.bottle-icon1, .bottle-icon2').css({'opacity': '1'});
              $('.unlock-wrapper').css({'opacity': '.3'});
              $('.lock-wrapper').css({'opacity': '1'});
          }
           else if (totalCount == 3 ) {
              $('.inner-bar').css({'max-width': '75%'}); 
              $('.pb-heading').text("Add 1 more sauce to unlock 30% off! ");
              $('.bottle-icon4').css({'opacity': '.3'});
              $('.bottle-icon1, .bottle-icon2, .bottle-icon3').css({'opacity': '1'});
              $('.unlock-wrapper').css({'opacity': '.3'});
              $('.lock-wrapper').css({'opacity': '1'});
          }
           else if (totalCount >= 4)  {
              $('.inner-bar').css({'max-width': '100%'}); 
              $('.pb-heading').text("Congrats! You've unlocked 30% off!");
              $('.bottle-icon1, .bottle-icon2, .bottle-icon3, .bottle-icon4').css({'opacity': '1'});
              $('.unlock-wrapper').css({'opacity': '1'});
               $('.lock-wrapper').css({'opacity': '.3'});
              confetti();
          }
          else {
            $('.inner-bar').css({'max-width': '0%'}); 
            $('.pb-heading').text("The more flavors you add to your cart, the spicier the savings get");
            $('.bottle-icon1, .bottle-icon2, .bottle-icon3, .bottle-icon4').css({'opacity': '.3'});
            $('.unlock-wrapper').css({'opacity': '.3'});
            $('.lock-wrapper').css({'opacity': '1'});
 
          }
      })
  }
  getCartJson();
}
updateProgressBar();
*/

/******/ })()
;